import React from 'react';
import { FUEL_PRICES } from '../data/fuelData';
import './PriceCards.scss';

function PriceCard({ fuel }) {
  const up = fuel.change > 0;
  const whole = Math.floor(fuel.price);
  const decimal = ((fuel.price % 1) * 10).toFixed(0);

  return (
    <div className="price-card">
      <div className="price-card__label">
        <span className="price-card__emoji">{fuel.emoji}</span>
        {fuel.id}
      </div>
      <div className="price-card__name">{fuel.full}</div>

      <div className="price-card__price">
        {whole}
        <span className="price-card__decimal">.{decimal}p</span>
        <span className="price-card__unit">/L</span>
      </div>

      <div className={`price-card__change price-card__change--${up ? 'up' : 'down'}`}>
        <span>{up ? '▲' : '▼'} {Math.abs(fuel.change)}p</span>
        <span className="price-card__pct">({up ? '+' : ''}{fuel.pct}%)</span>
        <span className="price-card__avg">7d avg: {fuel.avg7}p</span>
      </div>

      <div className="price-card__advice">
        ⚠️ {fuel.advice}
      </div>
    </div>
  );
}

export default function PriceCards() {
  return (
    <section id="prices" className="price-cards">
      <div className="price-cards__inner">
        <div className="price-cards__header">
          <p className="price-cards__label">Week of 21 Sept 2026 · UK National Average</p>
          <h2 className="price-cards__title">Live Fuel Prices</h2>
        </div>
        <div className="price-cards__grid">
          {FUEL_PRICES.map((fuel) => (
            <PriceCard key={fuel.id} fuel={fuel} />
          ))}
        </div>
        <p className="price-cards__source">
          Sourced from the UK Government Fuel Finder Scheme · Updated every 30 mins
        </p>
      </div>
    </section>
  );
}
